import Image from "next/image";

type AmplifyProductCardCardProps = {
	iconSrc: string;
	title: string;
	description: string;
};

const AmplifyProductsCard = ({ iconSrc, title, description }: AmplifyProductCardCardProps) => (
	<div className="m-4 rounded-md bg-white">
		<div className="flex items-center gap-3">
			<div className="h-10 w-10 md:h-12 md:w-fit">
				<Image
					src={iconSrc}
					alt={title}
					className="h-full w-full rounded object-contain"
					width={80}
					height={80}
				/>
			</div>
			<div>
				<h3 className="text-xs font-semibold text-gray-800">{title}</h3>
				<p className="text-start text-xxs text-gray-600">{description}</p>
			</div>
		</div>
	</div>
);

export default AmplifyProductsCard;
